import React from 'react'

export default props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
        <circle fill="#f15a24" cx="11" cy="11" r="11" />
        <path
            fill="#fff"
            d="M954.12,542.54a1.9,1.9,0,1,1,1.9-1.89A1.68,1.68,0,0,1,954.12,542.54Zm1.9-8.34a2,2,0,0,1,0,4,1.89,1.89,0,0,1-1.42-.59A2,2,0,0,1,956,534.2Zm0,12.45a1.58,1.58,0,1,1,1.58-1.58A1.39,1.39,0,0,1,956,546.65Zm4.42-9.8a2.53,2.53,0,1,1,2.53-2.53A2.24,2.24,0,0,1,960.44,536.85Zm0,11.38a1.27,1.27,0,1,1,1.27-1.26A1.11,1.11,0,0,1,960.44,548.23Zm4.47-2.17a1,1,0,1,1,1-.95A.84.84,0,0,1,964.91,546.06Zm0-9.52a.32.32,0,1,1,.32-.32A.29.29,0,0,1,964.87,536.54Zm1.9,4.74a.64.64,0,1,1,.63-.63A.56.56,0,0,1,966.77,541.28Z"
            transform="translate(-949.18 -529.01)"
        />
    </svg>
)
